<template>
  <div>
    <!-- 视频、图片 -->
    <el-dialog
      width="700px"
      class="detail-wrap"
      v-if="isShow"
      :visible.sync="isShow"
      :title="detailData.title"
      v-esc-close
    >
      <div class="video-wrap" v-if="+detailType === 1">
        <video
          v-if="detailData.video"
          :src="detailData.video"
          controls="controls"
          width="600"
          height="400"
        >
          您的浏览器不支持 video 标签。
        </video>
      </div>
      <div class="pic-wrap" v-if="+detailType === 0">
        <el-carousel
          height="500px"
          arrow="always"
          :autoplay="false"
          trigger="click"
        >
          <el-carousel-item v-for="item in detailData.pictures" :key="item">
            <el-image :src="item" fit="contain" class="pic-item"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ['data','detailType'],
  data() {
    return {
      detailData: {},
      isShow: false
    }
  },
  // watch: {
  //   data: {
  //     handler() {
  //       this.showDialog(this.data, this.detailType)
  //     },
  //     deep: true
  //   }
  // },
  methods: {
    showDialog(rowData, type) {
      let video = "";
      const pictures = [];

      // type: 1 video, 0 picture
      rowData.imgUrlList.forEach((item) => {
        if (+type === 0) {
          pictures.push(item.path);
        } else if (+type === 1) {
          video = item.url;
        }
      });

      this.detailData = {
        video,
        pictures,
        title: type === 1 ? "视频" : "图片",
      };

      this.isShow = true;
    }
  }
}
</script>


<style lang="stylus" scoped>
  .pic-item
    width 100%
    height 100%
</style>